
import { useOptimizedAuth } from "@/hooks/useOptimizedAuth";
import { Navigate } from "react-router-dom";
import Header from '@/components/header/ModernHeader';
import Footer from "@/components/Footer";
import ErrorBoundary from "@/components/ErrorBoundary";
import BackButton from "@/components/navigation/BackButton";

const Profile = () => {
  const { user, loading } = useOptimizedAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900 mx-auto"></div>
          <p className="mt-4 text-gray-600 font-light">Loading your profile...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-gray-50">
        <Header />
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-4xl mx-auto">
            <BackButton to="/" label="Back to Home" />
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Profile</h1>
            
            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center mb-6">
                <div className="w-20 h-20 bg-gray-300 rounded-full flex items-center justify-center">
                  <span className="text-2xl font-bold text-gray-600">
                    {user.email?.charAt(0).toUpperCase()}
                  </span>
                </div>
                <div className="ml-6">
                  <h2 className="text-xl font-semibold text-gray-900">
                    {user.user_metadata?.full_name || user.email}
                  </h2>
                  <p className="text-gray-600">{user.email}</p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <h3 className="text-lg font-medium text-gray-900 mb-4">Account Information</h3>
                  <div className="space-y-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Email</label>
                      <p className="mt-1 text-sm text-gray-900">{user.email}</p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Member Since</label>
                      <p className="mt-1 text-sm text-gray-900">
                        {new Date(user.created_at).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-gray-900 mb-4">Quick Actions</h3>
                  <div className="space-y-3">
                    <a
                      href="/settings"
                      className="block w-full text-left px-4 py-2 bg-blue-50 hover:bg-blue-100 rounded-md text-blue-700 font-medium"
                    >
                      Edit Profile Settings
                    </a>
                    <a
                      href="/orders"
                      className="block w-full text-left px-4 py-2 bg-green-50 hover:bg-green-100 rounded-md text-green-700 font-medium"
                    >
                      View Order History
                    </a>
                    <a
                      href="/wishlist"
                      className="block w-full text-left px-4 py-2 bg-purple-50 hover:bg-purple-100 rounded-md text-purple-700 font-medium"
                    >
                      View Wishlist
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </ErrorBoundary>
  );
};

export default Profile;
